import { render, staticRenderFns } from "./acceptedSupervision.vue?vue&type=template&id=61c5b146&scoped=true"
import script from "./acceptedSupervision.vue?vue&type=script&lang=js"
export * from "./acceptedSupervision.vue?vue&type=script&lang=js"
import style0 from "./acceptedSupervision.vue?vue&type=style&index=0&id=61c5b146&prod&lang=scss&scoped=true"
import style1 from "./acceptedSupervision.vue?vue&type=style&index=1&id=61c5b146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c5b146",
  null
  
)

export default component.exports